// =============================================================================
// Capa de transporte HTTP (hallazgo A3 resuelto)
// -----------------------------------------------------------------------------
// Todas las vistas/composables importan `http` (nunca `apiClient` directo).
// Contrato IDÉNTICO a Axios (la respuesta incluye `.data`), por lo que la
// migración es transparente:
//   - `http.get(url, config)`, `http.post(url, body, config)`, etc.
// En el camino de ERROR se normaliza a `ApiError` (A4/A5) preservando `.response`
// para compatibilidad con bindings existentes.
// =============================================================================
import apiClient from '@/api/client';
import { normalizeApiError } from '@/utils/apiError';
import { enqueueMutation } from '@/utils/offlineQueue';

// RX-5: rutas públicas que NUNCA deben encolarse (login/refresh).
const isPublicUrl = (url) => ['/login', '/refresh', '/password/']
  .some((prefix) => String(url || '').startsWith(prefix));

const call = async (method, url, ...args) => {
  try {
    return await apiClient[method](url, ...args);
  } catch (error) {
    // RX-5: si la máquina está offline y la operación muta datos (no es GET),
    // la encolamos para reintentarla al reconectar (cola de reintentos).
    const offlineNetwork = error && error.isAxiosError && !error.response
      && typeof navigator !== 'undefined' && navigator.onLine === false;
    if (offlineNetwork && method !== 'get' && !isPublicUrl(url)) {
      try {
        enqueueMutation({ method, url, data: args[0] ?? null, config: args[1] ?? null });
      } catch (queueError) {
        console.warn('No se pudo encolar la operación offline:', queueError);
      }
    }
    throw normalizeApiError(error);
  }
};

export const http = {
  get: (url, config) => call('get', url, config),
  post: (url, data, config) => call('post', url, data, config),
  put: (url, data, config) => call('put', url, data, config),
  patch: (url, data, config) => call('patch', url, data, config),
  delete: (url, config) => call('delete', url, config),
};

export { normalizeApiError } from '@/utils/apiError';
export { ApiError, getErrorMessage } from '@/utils/apiError';